function formatPhone(phone) {
    const areaCode = '972';
    const value = String(phone);
    return value.startsWith(areaCode) ? `0${value.substring(areaCode.length)}` : value;
}

export function formatPhoneDisplay(phone) {
    const digits = String(phone || '').replace(/\D/g, '');
    const local = digits.startsWith('972') ? `0${digits.slice(3)}` : digits;
    if(!local.startsWith('0') || local.length < 8) return formatPhone(phone);
    return `${local.slice(0, -7)}-${local.slice(-7)}`;
}

export default formatPhone;
